export default "__VITE_ASSET__607de2a3__"